import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { BookingFeesDialogComponent } from './booking-fees-dialog.component'
import { Rental } from '@tokeet/tv3-platform'

@Injectable()
export class BookingFeesDialogService {
  constructor(private dialog: MatDialog) {}

  open(rental: Rental) {
    const defaultConfig: MatDialogConfig = {
      width: '900px',
      height: '540px',
      data: { rental },
      panelClass: ['variable-modal'],
    }

    return this.dialog.open(BookingFeesDialogComponent, defaultConfig)
  }
}
